import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementZhTWLocale from 'element-ui/lib/locale/lang/zh-TW'
import enLocale from './en'
import zhLocale from './zh'
import zhTWLocale from './zh_TW'
import koLocale from './ko'
import jpLocale from './jp'
import idLocale from './id'
import { getDefaultLang } from '@/utils/languageConfig'

Vue.use(VueI18n)

const messages = {
    en: {
        ...enLocale,
        ...elementEnLocale
    },
    zh: {
        ...zhLocale,
        ...elementZhLocale
    },
    zh_TW: {
        ...zhTWLocale,
        ...elementZhTWLocale
    },
    ko: {
        ...koLocale
        // ...elementKoLocale (如果有韩文element-ui包)
    },
    jp: {
        ...jpLocale
        // ...elementJaLocale (如果有日文element-ui包)
    },
    id: {
        ...idLocale
        // ...elementFrLocale (如果有法文element-ui包)
    }
}

const i18n = new VueI18n({
    locale: Cookies.get('language') || localStorage.getItem('lang') || getDefaultLang(),
    // 缺少某语言的文案时回退到中文，避免界面直接显示 key（新增功能先落 zh/en，其余语言逐步补）
    fallbackLocale: 'zh',
    messages
})

export default i18n
